import HMAConfig from "@/views/configs/hma/index.vue";

export default [
  {
    path: "hma",
    name: "H.M.A",
    component: HMAConfig,
  },
];
